module.exports = __webpack_public_path__ + "static/media/azure_active_directory_logo.94e24a04.png";